var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000096028372600920084050000015280760631202877338_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#801950;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.7,184.2v-30.2c0-11,8.9-20,20-20.1l162.4-1.2h30c5.3,0,10.4-2.1,14.2-5.9l14.4-14.4 c3.8-3.8,8.9-5.9,14.2-5.9h67.9c11.1,0,20.1,9,20.1,20.1v57.9L85.7,184.2L85.7,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431,199c13.2,0,23.6,11.2,22.5,24.4L441,379.5c0,14.2-19.5,25.9-43.3,25.9H114.9c-23.8,0-43.3-11.7-43.3-25.9 l-13-156.1c-1.1-13.2,9.3-24.5,22.5-24.5L431,199L431,199z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOn);
export default __webpack_public_path__ + "static/media/file_on.c5ebf57e6def1d44e3883983d1d427bd.svg";
export { ForwardRef as ReactComponent };